/**
 * Matches raw inputs like "830A", "1115PM", or "07A".
 * Captures:
 *   - Group 1: the numeric time (1-4 digits)
 *   - Group 2: AM/PM (with or without 'M')
 */
export const COMPACT_TIME_WITH_PERIOD_REGEX = /^(\d{1,4})([AP]M?)$/;

/**
 * Matches only digit-based inputs.
 * Used to decide whether to apply manual parsing logic.
 * Examples: "7", "830", "1530"
 */
export const DIGIT_ONLY_TIME_REGEX = /^\d+$/;

/**
 * Filters out strings that clearly contain invalid time characters.
 * Allows only digits, colon, spaces, and AM/PM indicators.
 * Used as a guard before fallback parsing.
 */
export const VALID_TIME_CHARACTERS_REGEX = /^[\d\s:APMapm]+$/;

/**
 * Matches one or more whitespace characters (used to strip all spacing).
 * Example: "  8 : 30  am  " → "8:30am"
 */
export const ALL_WHITESPACE_REGEX = /\s+/g;

/** Input format patterns supported by dayjs for parsing. */
export const timeFormats = {
  '12-hour': ['h:mm A', 'h:mm', 'h A', 'h', 'hmmA', 'HmmA', 'hmm'],
  '24-hour': ['H:mm', 'H', 'Hmm', 'HHmm', 'hmm'],
};

/** Output format patterns used to standardize parsed time strings. */
export const outputFormat = {
  '12-hour': 'h:mm A',
  '24-hour': 'HH:mm',
};
